// import {getEnv} from '../shared/Services/env'
import localVars from '../shared/Data/localVars'

let store;
// const isElectron = !!window.require;

// if (isElectron) {
//   // Use IPC-based store for Electron
//   store = require('./electronStore').default;
//   const ipc = window.require('electron').ipcRenderer;

//   ipc.on('receive-key', (event, arg) => {
//     if (arg[0] !== 'L_KEY') return;
//     try {
//       console.log('Store ready via IPC');
//     } catch (e) {
//       console.log('Caught error initializing store via IPC:', e);
//     }
//     ipc.send('key-ready', 'L_KEY');
//   });

//   ipc.send('request-key', 'L_KEY');
// } else {
  // Use localStorage for web version
  console.log('Running in web mode, using localStorage for storage.');
  store = {
    get: async (key) => {
      const item = localStorage.getItem(key);
      try {
        return JSON.parse(item);
      } catch (e) {
        return item; // Return as is if not JSON
      }
    },
    set: async (key, value) => localStorage.setItem(key, JSON.stringify(value)),
    has: async (key) => localStorage.getItem(key) !== null,
    delete: async (key) => localStorage.removeItem(key),
    clear: async () => localStorage.clear(),
    getAll: async () => {
      const allItems = {};
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        try {
          allItems[key] = JSON.parse(localStorage.getItem(key));
        } catch (e) {
          allItems[key] = localStorage.getItem(key);
        }
      }
      return allItems;
    },
  };
// }

const locals = {...localVars.PC, ...localVars.SHARED}

let checkSlot = function(slot){
  for( let localVar in locals ) {
    if( slot === locals[localVar] ) return true
  }
  return false
}

let getLocal = async function(slot){
   if( checkSlot(slot) ) {
     const item = await store.get(slot)
     return Promise.resolve(item)
   }
   const e = `getLocal: Slot '${slot}' does not exist. Describe it in /shared/Data/localVars.js before use.`
   console.warn(e)
   throw new Error(e)
  // return undefined
}

let setLocal = async function(slot, item){
  if( checkSlot(slot) ){
    await store.set(slot, item)
    // console.log('set slot', slot, item)
    return Promise.resolve()
  }
  const e = `setLocal: Slot '${slot}' does not exist. Describe it in /shared/Data/localVars.js before use.`
  console.warn(e)
  throw new Error(e)
}

let fastSetLocal = async function(slot, item){
  return checkSlot(slot) ? store.set(slot, item) : null
}

let fastGetLocal = async function(slot, item){
  return checkSlot(slot) ? store.get(slot) : null
}

let clear = async function(){
  return store.clear()
}

window.setLocal = setLocal
window.getLocal = getLocal
window._ms_store = store

export { getLocal, setLocal, fastSetLocal, fastGetLocal, clear}
